import { useState } from 'react';
import { useLocation, useParams } from 'react-router';
import queryString from 'query-string';
import { getLifebookVideo } from 'services';
import { useFormInput } from 'helpers';
import { PageLayout, TextField, PrimaryButton, InfoTag } from 'components';
import styles from './lifebookVideo.module.css';

// Opened from a QR code in a LifeBook PDF (video.ella.care/<post id hex>[-N]); works without logging in.
export function LifebookVideo() {
	const { id } = useParams();
	// shortcut: ?post=&video= links only exist in Sandbox test PDFs; drop them once those are gone.
	const query = queryString.parse(useLocation().search || '');
	const [hex, index] = (id || '').split('-');
	const postId = query.post || (hex && `pst_${hex}`);
	const video = Number(query.video ?? index ?? 0);
	const code = useFormInput('Video Code', '', { required: true });
	const [result, setResult] = useState(null);
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const onSubmit = () => {
		if (!code.value.trim()) return;
		setLoading(true);
		setError('');
		getLifebookVideo({ postId, video, code: code.value })
			.then(({ data }) => setResult(data))
			.catch((err) =>
				setError(
					err?.response?.data?.message ||
						'Sorry, this video could not be opened. Please try again.'
				)
			)
			.finally(() => setLoading(false));
	};

	code.onKeyDown = (e) => {
		if (e.keyCode === 13) onSubmit();
	};

	if (!postId) {
		return (
			<PageLayout title='LifeBook Video'>
				<div className={styles.root}>
					This link is incomplete. Please scan the QR code again.
				</div>
			</PageLayout>
		);
	}

	return (
		<PageLayout title='LifeBook Video'>
			<div className={styles.root}>
				{result ? (
					<>
						<div className={styles.title}>{result.title}</div>
						<video className={styles.video} src={result.url} controls playsInline />
					</>
				) : (
					<>
						<InfoTag>
							Enter the video code printed at the front of your LifeBook.
						</InfoTag>
						<TextField {...code} placeholder='7K3M-9R2W-6X8P' />
						{error && <div className={styles.error}>{error}</div>}
						<div className={styles.button}>
							<PrimaryButton onClick={onSubmit} disabled={loading}>
								Watch Video
							</PrimaryButton>
						</div>
					</>
				)}
			</div>
		</PageLayout>
	);
}

export default LifebookVideo;
